var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMehmetakif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.1.2c3.6.6,6.8.8,9.4,3.9,4,4.9,9,8.2,16,7.2,2.3-.4,3.9.3,3.4,3.4-1.1,6.7-4.5,12.4-7,18.5-.2.6-1.1,1.2-1.7,1.4-2.9,1-13.5-2.5-14.8-5.2C7.5,21.8,3.8,14.2.3,6.5-1,3.8,2.6.2,6.1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMehmetakif);
export default __webpack_public_path__ + "static/media/mehmetakif.a568c66e891acfb51493094906b263c3.svg";
export { ForwardRef as ReactComponent };